import React, {FunctionComponent, useEffect, useRef, useState} from "react";


const Modal:FunctionComponent<any> = function (props) {
    const {stateChange, htmlContent, children, headerContent, showButtonClose, visible, isNormal} = props;
    const modalElement = useRef();
    const [modalVisible, setModalVisible] = useState(visible);
    const handleTurnOff = function(e: React.MouseEvent<HTMLElement>) {

        setModalVisible(false);
        if (stateChange) {
            stateChange(false);
        }
        if ((e.target as HTMLElement).className.search('modal') > -1 || (e.target as HTMLElement).className === 'close') {
        }
    }
    useEffect(() => {
        if(modalVisible) {
            // @ts-ignore
            $(".modal.download").modal("show");
            $("body").off("hidden.bs.modal").on("hidden.bs.modal", ".modal.download", () => {
                setModalVisible(false);
                if (stateChange) {
                    stateChange(false);
                }
            })
        } else {
            // @ts-ignore
            $(".modal.download").modal("hide");
        }
    }, [modalVisible]);
    return (
        <div className={isNormal ? "modal download sd-modal" : "modal download instructional-modal"}>
            <div className="modal-dialog modal-dialog-scrollable" role="document">
                <div className="modal-content">
                    <div className={isNormal ? "sd-modal-header" : "modal-header"}>
                        <h4 style={{textAlign: "center"}}>{headerContent}</h4>
                        <button type="button" className="close-btn model-close icon-close" onClick={handleTurnOff} data-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                    <div className="modal-body">
                        {htmlContent && <div className="content-wrapper" dangerouslySetInnerHTML={{ __html: htmlContent }} />}
                        {children}
                        {(htmlContent || children) ? '' : <div className="sd-modal loading"><div className="lds-dual-ring"></div></div>}
                    </div>
                    {showButtonClose && (<div className="modal-footer">
                        <button type="button" className="btn btn-primary btn-common contained-btn cta-active cls-terms-modal" onClick={handleTurnOff} data-dismiss="modal">Close</button>
                    </div>)}
                </div>
            </div>
        </div>)
}
export default Modal;